import React from 'react';
import PropTypes from 'prop-types';
import {
	Modal as ToolkitModal,
	ModalHeader as ToolkitModalHeader,
	ModalBody as ToolkitModalBody,
	ModalFooter as ToolkitModalFooter,
	ConfirmationModal as ToolkitConfirmationModal,
} from '@quantum-ecosystem/ui-toolkit';

export const FormModal = ({
	opened,
	show,
	onClose,
	onHide,
	title,
	withCloseButton = true,
	closeOnClickOutside = true,
	closeOnEscape = true,
	size = 'md',
	centered, // Destructured to avoid invalid DOM attribute; toolkit centers modals by default
	scrollAreaComponent, // Destructured to avoid invalid DOM attribute
	className,
	bodyClassName,
	children,
	...restProps
}) => {
	const isVisible = Boolean(show ?? opened);
	const handleClose = onHide || onClose || (() => {});
	const handleModalHide = closeOnClickOutside && closeOnEscape ? handleClose : () => {};

	// Map sizes to Toolkit size and custom class names
	let toolkitSize = 'md';
	let sizeClassName = '';

	if (size === 'sm') {
		toolkitSize = 'sm';
	} else if (size === 'md') {
		toolkitSize = 'md';
	} else if (size === 'lg') {
		toolkitSize = 'lg';
	} else if (size === 'xl') {
		sizeClassName = 'q-modal-size-xl';
		toolkitSize = 'lg';
	} else if (size === '75%') {
		sizeClassName = 'q-modal-size-75';
		toolkitSize = 'lg';
	} else if (size === '80%') {
		sizeClassName = 'q-modal-size-80';
		toolkitSize = 'lg';
	} else if (size === 'auto') {
		sizeClassName = 'q-modal-size-auto';
		toolkitSize = 'md';
	} else if (typeof size === 'string') {
		sizeClassName = 'q-modal-size-custom';
	}

	const combinedClassName = [sizeClassName, className]
		.filter(Boolean)
		.join(' ');

	const hasHeader = (title !== undefined && title !== null) || withCloseButton;

	return (
		<ToolkitModal
			show={isVisible}
			onHide={handleModalHide}
			size={toolkitSize}
			className={combinedClassName}
			{...restProps}
		>
			{hasHeader ? (
				<>
					<ToolkitModalHeader
						title={title}
						onHide={withCloseButton ? handleClose : undefined}
					/>
					<ToolkitModalBody className={bodyClassName}>
						{children}
					</ToolkitModalBody>
				</>
			) : (
				children
			)}
		</ToolkitModal>
	);
};

FormModal.Header = ToolkitModalHeader;
FormModal.Body = ToolkitModalBody;
FormModal.Footer = ToolkitModalFooter;
FormModal.Confirmation = ToolkitConfirmationModal;

FormModal.propTypes = {
	opened: PropTypes.bool,
	show: PropTypes.bool,
	onClose: PropTypes.func,
	onHide: PropTypes.func,
	title: PropTypes.node,
	withCloseButton: PropTypes.bool,
	closeOnClickOutside: PropTypes.bool,
	closeOnEscape: PropTypes.bool,
	size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	centered: PropTypes.bool,
	scrollAreaComponent: PropTypes.any,
	className: PropTypes.string,
	bodyClassName: PropTypes.string,
	children: PropTypes.node,
};

export default FormModal;
